import { fmtNum, formattedTime } from "../../Services/processo/dashboardProcessoUtils";



/**
 * recebe o objeto estatistica  {realizado, planejado, realizadoPct, frequenciaPlanejada, frequenciaRealizada , frequenciaPct } e exibe uma barra de progresso fina e compacta usando react-bootstrap
 * @param {*} param0 
 * @returns 
 */
const EstatisticasFrequenciaDashboard = ({ titulo, estatisticas }) => {
    const totalControles = estatisticas?.totalControles || 0;
    const realizado = estatisticas?.realizado || 0;
    const planejado = estatisticas?.planejado || 0;
    const frequenciaPlanejada = estatisticas?.frequenciaPlanejada || 0;
    const frequenciaRealizada = estatisticas?.frequenciaRealizada || 0;
    const frequenciaPct = estatisticas?.frequenciaPct;
    const realizadoPct = (estatisticas.realizadoPct*100).toFixed(2) 

   

    return (
        <div>
            <div className="text-muted small">{titulo || `Frequência`}</div>
            <div className="d-flex align-items-center">
                <div className="progress flex-grow-1" style={{ height: '8px' }}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${realizadoPct}%` }}
                        aria-valuenow={realizadoPct}
                        aria-valuemin="0"
                        aria-valuemax="1"
                    ></div>
                </div>
                <div className="ms-2" style={{ minWidth: '50px', textAlign: 'right', fontSize: '0.875rem' }}>
                    {realizadoPct}%
                </div>
            </div>
            {/* se nao tem total controles nao renderiza Controles */}
            <div className="small text-muted">
                {totalControles > 0 ? `Controles: ${totalControles} • ` : ''}
                Realizado: {fmtNum(realizado, 0)} • Planejado: {fmtNum(planejado, 0)} 
            </div>
            {(frequenciaPlanejada > 0 || frequenciaRealizada > 0 || frequenciaPct !== undefined) && (
                <div className="small text-muted">
                    {totalControles > 0 ? `Controles: ${totalControles} • ` : ''}
                    {frequenciaPlanejada > 0 && `Frequência 1 vez a cada: ${formattedTime(frequenciaPlanejada)} • `}
                    {frequenciaRealizada > 0 && `Realizada 1 a cada: ${formattedTime(frequenciaRealizada)} `}
                    {frequenciaPct !== undefined && `•Proximidade da frequência: ${fmtNum(frequenciaPct, 1)}%`}
                </div>
            )}
        </div>
    );
};



export default EstatisticasFrequenciaDashboard;
